module.exports = __webpack_public_path__ + "media/new2.f7e8cf70.mp4";